import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import { CiHeart } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../API/config";
import { Rate } from "antd";
import { useMediaQuery } from "react-responsive";

const CompareCard = ({ product }: { product: any }) => {

  const navigate = useNavigate();

  const handleNavDetails = (slug: string, categories: string) => {
    navigate(`/product/${categories}/${slug}`);
  };


  const isMobile = useMediaQuery({ maxWidth: 998 });
  const displayedProducts = isMobile ? product.slice(0, 2) : product;


  // Return early if product is undefined or not an array
  if (!Array.isArray(product)) {
    return <p>No products available.</p>;
  }

  return (
    <>
      {displayedProducts.map((val: any, i: number) => {
        return (
          <div className="col-lg-3 col-md-4 col-sm-6 col-6" key={val?._id}>
            <Card>
              <div
                className="position-relative card-div"
                style={{
                  cursor: "pointer",
                  background:
                    "linear-gradient(180deg, #CECECE 0%, #FFFFFF 41.34%, #CECECE 100%)",
                }}
                onClick={() => handleNavDetails(val.slug, val.categories)}
              >
                <Card.Img
                  className="p-0 card-img"
                  variant="top"
                  src={`${val?.variants[0].images[0] || "-"}`}
                 
                />
                {/* <div className="heart-badge">
                  <CiHeart />
                </div> */}
              </div>
              <Card.Body>
                <div className="text-center">
                  <h3 className="card-title text-center">
                    {val?.product || "-"}
                  </h3>
                </div>

                <p className="mb-0 spec-card text-center">
                  {val?.description?.screenSize || "-"}
                </p>

                <div className="text-center">
                  <p className="card-offprice">
                    ₹ {val?.variants[0].dealPrice.toFixed(2) || "-"}{" "}
                    <span>
                      MRP: ₹
                      <span style={{ textDecoration: "line-through" }}>
                        {val?.variants[0].price.toFixed(2) || "-"}
                      </span>
                    </span>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </div>
        );
      })}
      <div className="pt-3">
        <table className="table-view">
          {product.some((p) => p?.variants[0]?.dealPrice) && (
            <tr>
              <th>Prize</th>
              <th>₹ {product[0]?.variants[0]?.dealPrice?.toFixed(2) || "-"}</th>
              <th>₹ {product[1]?.variants[0]?.dealPrice?.toFixed(2) || "-"}</th>
              <th>₹ {product[2]?.variants[0]?.dealPrice?.toFixed(2) || "-"}</th>
            </tr>
          )}

          {product.some((p) => p?.rating) && (
            <tr>
              <td>Rating</td>
              <td>
                <Rate
                  disabled
                  value={product[0]?.rating}
                  allowHalf
                  className="rate-table"
                />
              </td>
              <td>
                <Rate
                  disabled
                  value={product[1]?.rating}
                  allowHalf
                  className="rate-table"
                />
              </td>
              <td>
                <Rate
                  disabled
                  value={product[2]?.rating}
                  allowHalf
                  className="rate-table"
                />
              </td>
            </tr>
          )}
   {product.some((p) => p?.detailsOverview?.display) && (
            <tr>
              <td>Display</td>
              <td>{product[0]?.detailsOverview?.display || "-"}</td>
              <td>{product[1]?.detailsOverview?.display || "-"}</td>
              <td>{product[2]?.detailsOverview?.display || "-"}</td>
            </tr>
          )}
          {product.some((p) => p?.description?.screenSize) && (
            <tr>
              <td>Display size</td>
              <td>{product[0]?.description?.screenSize || "-"}</td>
              <td>{product[1]?.description?.screenSize || "-"}</td>
              <td>{product[2]?.description?.screenSize || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.description?.memoryStorage) && (
            <tr>
              <td>Memory capacity </td>
              <td>{product[0]?.description.memoryStorage || "-"}</td>
              <td>{product[1]?.description.memoryStorage || "-"}</td>
              <td>{product[2]?.description.memoryStorage || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.description?.model) && (
            <tr>
              <td>Model name</td>
              <td>{product[0]?.description.model || "-"}</td>
              <td>{product[1]?.description.model || "-"}</td>
              <td>{product[2]?.description.model || "-"}</td>
            </tr>
          )}
        

          {product.some((p) => p?.description?.memoryStorage) && (
            <tr>
              <td>Operating system </td>
              <td>{product[0]?.description.os || "-"}</td>
              <td>{product[1]?.description.os || "-"}</td>
              <td>{product[2]?.description.os || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.description?.connectionTechnology) && (
            <tr>
              <td>Connectivity tech</td>
              <td>{product[0]?.description.connectionTechnology || "-"}</td>
              <td>{product[1]?.description.connectionTechnology || "-"}</td>
              <td>{product[2]?.description.connectionTechnology || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.description?.displayTech) && (
            <tr>
              <td>Display type </td>
              <td>{product[0]?.description.displayTech || "-"}</td>
              <td>{product[1]?.description.displayTech || "-"}</td>
              <td>{product[2]?.description.displayTech || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.description?.processor) && (
            <tr>
              <td>Processor </td>
              <td>{product[0]?.description.processor || "-"}</td>
              <td>{product[1]?.description.processor || "-"}</td>
              <td>{product[2]?.description.processor || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.additionalOverview?.gpsNavigation) && (
            <tr>
              <td>GPS navigation</td>
              <td>{product[0]?.additionalOverview?.gpsNavigation || "-"}</td>
              <td>{product[1]?.additionalOverview?.gpsNavigation || "-"}</td>
              <td>{product[2]?.additionalOverview?.gpsNavigation || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.description?.specialFeature) && (
            <tr>
              <td>Cellular technology</td>
              <td>{product[0]?.description.specialFeature || "-"}</td>
              <td>{product[1]?.description.specialFeature || "-"}</td>
              <td>{product[2]?.description.specialFeature || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.additionalOverview?.weight) && (
            <tr>
              <td>Weight</td>
              <td>{product[0]?.additionalOverview?.weight || "-"}</td>
              <td>{product[1]?.additionalOverview?.weight || "-"}</td>
              <td>{product[2]?.additionalOverview?.weight || "-"}</td>
            </tr>
          )}
          {product.some((p) => p?.additionalOverview?.waterResistance) && (
            <tr>
              <td>Water resistance </td>
              <td>{product[0]?.additionalOverview?.waterResistance || "-"}</td>
              <td>{product[1]?.additionalOverview?.waterResistance || "-"}</td>
              <td>{product[2]?.additionalOverview?.waterResistance || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.additionalOverview?.noOfUsbPort) && (
            <tr>
              <td>No.of USB port</td>
              <td>{product[0]?.additionalOverview?.noOfUsbPort || "-"}</td>
              <td>{product[1]?.additionalOverview?.noOfUsbPort || "-"}</td>
              <td>{product[2]?.additionalOverview?.noOfUsbPort || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.additionalOverview?.inputInterface) && (
            <tr>
              <td>Input interface </td>
              <td>{product[0]?.additionalOverview?.inputInterface || "-"}</td>
              <td>{product[1]?.additionalOverview?.inputInterface || "-"}</td>
              <td>{product[2]?.additionalOverview?.inputInterface || "-"}</td>
            </tr>
          )}
          {product.some((p) => p?.additionalOverview?.memorySlot) && (
            <tr>
              <td>Memory slot </td>
              <td>{product[0]?.additionalOverview?.memorySlot || "-"}</td>
              <td>{product[1]?.additionalOverview?.memorySlot || "-"}</td>
              <td>{product[2]?.additionalOverview?.memorySlot || "-"}</td>
            </tr>
          )}
          {product.some((p) => p?.additionalOverview?.cpuManufacture) && (
            <tr>
              <td>CPU manufacture</td>
              <td>{product[0]?.additionalOverview?.cpuManufacture || "-"}</td>
              <td>{product[1]?.additionalOverview?.cpuManufacture || "-"}</td>
              <td>{product[2]?.additionalOverview?.cpuManufacture || "-"}</td>
            </tr>
          )}

          {product.some((p) => p?.additionalOverview?.hardwareInterface) && (
            <tr>
              <td>Hardware interface </td>
              <td>
                {product[0]?.additionalOverview?.hardwareInterface || "-"}
              </td>
              <td>
                {product[1]?.additionalOverview?.hardwareInterface || "-"}
              </td>
              <td>
                {product[2]?.additionalOverview?.hardwareInterface || "-"}
              </td>
            </tr>
          )}

          {product.some((p) => p?.additionalOverview?.wirelessTech) && (
            <tr>
              <td>Wireless tech</td>
              <td>{product[0]?.additionalOverview?.wirelessTech || "-"}</td>
              <td>{product[1]?.additionalOverview?.wirelessTech || "-"}</td>
              <td>{product[2]?.additionalOverview?.wirelessTech || "-"}</td>
            </tr>
          )}

{product.some((p) => p?.detailsOverview?.batteryLife) && (
            <tr>
              <td>Battery Life</td>
              <td>{product[0]?.detailsOverview?.batteryLife || "-"}</td>
              <td>{product[1]?.detailsOverview?.batteryLife || "-"}</td>
              <td>{product[2]?.detailsOverview?.batteryLife || "-"}</td>
            </tr>
          )}
          {product.some((p) => p?.detailsOverview?.cameraSystem) && (
            <tr>
              <td>Camera</td>
              <td>{product[0]?.detailsOverview?.cameraSystem || "-"}</td>
              <td>{product[1]?.detailsOverview?.cameraSystem || "-"}</td>
              <td>{product[2]?.detailsOverview?.cameraSystem || "-"}</td>
            </tr>
          )}
          
        </table>
      </div>
    </>
  );
};

export default CompareCard;
